import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface StarsIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const StarsIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: StarsIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M13.5928 3.90757C13.7107 3.53204 14.2422 3.53204 14.3601 3.90758L15.641 7.9859C15.6804 8.11139 15.7787 8.20967 15.9041 8.24908L19.9825 9.52993C20.358 9.64788 20.358 10.1793 19.9825 10.2973L15.9041 11.5781C15.7787 11.6175 15.6804 11.7158 15.641 11.8413L14.3601 15.9196C14.2422 16.2952 13.7107 16.2952 13.5928 15.9196L12.3119 11.8413C12.2725 11.7158 12.1742 11.6175 12.0487 11.5781L7.97041 10.2973C7.59488 10.1793 7.59488 9.64788 7.97041 9.52993L12.0487 8.24908C12.1742 8.20967 12.2725 8.11139 12.3119 7.9859L13.5928 3.90757Z"
                fill={color}
            />
            <path
                d="M7.24918 12.5347C7.35295 12.1324 7.92422 12.1324 8.02798 12.5347L8.63446 14.8857C8.67101 15.0275 8.78168 15.1381 8.92341 15.1747L11.2745 15.7812C11.6767 15.8849 11.6767 16.4562 11.2745 16.56L8.92341 17.1664C8.78168 17.203 8.67101 17.3137 8.63446 17.4554L8.02798 19.8064C7.92422 20.2087 7.35295 20.2087 7.24918 19.8064L6.64271 17.4554C6.60615 17.3137 6.49548 17.203 6.35376 17.1664L4.00271 16.56C3.60045 16.4562 3.60045 15.8849 4.00271 15.7812L6.35376 15.1747C6.49548 15.1381 6.60615 15.0275 6.64271 14.8857L7.24918 12.5347Z"
                fill={color}
            />
        </svg>
    )
}

export default StarsIcon
